export default __webpack_public_path__ + "static/media/Aura-Egg__47.8470bb66.png";